import { FC } from 'react';

import { IconProps } from '../types';

export const TelegramIcon: FC<IconProps> = ({
	size,
	height = 17,
	width = 20,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 17"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			d="m7.02 14.42.28-4.224 7.67-6.91c.34-.31-.07-.46-.519-.19L4.984 9.078.889 7.78c-.879-.25-.889-.86.2-1.299L17.038.33c.729-.33 1.428.18 1.148 1.299L15.47 14.42c-.19.909-.74 1.128-1.498.709l-4.135-3.056-1.987 1.927c-.23.23-.42.42-.83.42Z"
		/>
	</svg>
);
